import { Component } from '@angular/core'
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular'
import { Storage } from '@ionic/storage'
import { TranslateService } from '@ngx-translate/core'

// Pages
import { MainPage } from '../main/main'

@IonicPage()
@Component({
  selector: 'page-tutorial',
  templateUrl: 'tutorial.html',
})

export class TutorialPage {
  defaultLan
  isDesktop = false
  isShown = false

  constructor(
    private platform: Platform,
    public translate: TranslateService,
    public navCtrl: NavController,
    public Platform: Platform,
    public navParams: NavParams,
    private storage: Storage) {}

    ionViewDidLoad () {
      this.defaultLan = this.platform.getQueryParam('lang') || 'es'
      this.translate.setDefaultLang(this.defaultLan)
    }


    ionViewWillEnter () {
      console.log('Tutorial runs')
      this.isDesktop = this.Platform.is('core')
  
    }

    async nextSlide(slide:any) {
      await slide._slides.slideNext();
    }

    async prevSlide(slide:any){
      await slide._slides.slidePrev();
    }

    changeLanguage(lan) {
      this.translate.setDefaultLang(lan)
    }

  setTutorial(done: boolean) {
    this.storage.set('welcomeTutorial', done) 
  }

  goToMain () {
    this.navCtrl.push(MainPage, {}, {animate: true, direction: 'forward', animation: 'wp-transition', duration: 500})
  }

  handleContinue () {
    // this.setTutorial(true)
    this.goToMain()
  }

  handleSkip() {
    // this.setTutorial(true)
    this.goToMain()

  }

}



// WEBPACK FOOTER //
// ./src/pages/tutorial/tutorial.ts